import type { ReactNode } from 'react';

import { CloudDiscoveryKey } from '../../../utils/contexts';
import { useCloudPlatformDiscovery } from '../../../utils/hooks';
import { NotFoundPage } from '../../ErrorPage';

interface RequireDiscoveryKeyProps {
  children: ReactNode;
  discoveryKey: CloudDiscoveryKey;
}

export const RequireDiscoveryKey = ({ children, discoveryKey }: RequireDiscoveryKeyProps) => {
  const cloudPlatformDiscovery = useCloudPlatformDiscovery();

  if (!cloudPlatformDiscovery?.[discoveryKey]) return <NotFoundPage />;

  return <>{children}</>;
};
